// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"388":"534f1d35","678":"component---src-pages-index-js"}[chunkId] + "-" + {"388":"bc10ea9515a9f5ab4bc1","678":"d3989bab72cd471cf0b5"}[chunkId] + ".js";
};